import { useState, useEffect } from 'react';

// Hook para detectar status de conexão
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // Mostrar mensagem de reconexão
        setWasOffline(false);
      }
    };
    
    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  return { isOnline, wasOffline };
}

// Componente de banner offline
export function OfflineBanner() {
  const { isOnline } = useOnlineStatus();
  const [showReconnected, setShowReconnected] = useState(false);
  const [prevOnline, setPrevOnline] = useState(true);

  useEffect(() => {
    if (!prevOnline && isOnline) {
      // Acabou de reconectar
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    }
    setPrevOnline(isOnline);
  }, [isOnline, prevOnline]);

  if (isOnline && !showReconnected) {
    return null;
  }

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-[9999] px-4 py-2 text-center text-sm font-medium transition-all ${
        isOnline 
          ? 'bg-green-500 text-white' 
          : 'bg-red-500 text-white'
      }`}
    >
      {isOnline ? (
        <span>✅ Conexão restaurada!</span>
      ) : (
        <span>📡 Você está offline. Alguns dados podem estar desatualizados.</span>
      )}
    </div>
  );
}

// Componente de indicador discreto
export function OfflineIndicator() {
  const { isOnline } = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-20 left-4 z-50">
      <div className="bg-red-500/90 text-white text-xs px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg">
        <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
        Offline
      </div>
    </div>
  );
}

export default OfflineBanner;
